import styled from "styled-components/macro";
import { BREAKPOINT_MOBILE, Z_INDEX } from "../../../constants/constants";

const CallIndicatorStyles = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 1em;
  width: 100%;
  max-width: 40em;
  font-size: 1em;

  .call-indicator-label {
    opacity: 0.7;
    width: 25%;
    max-width: 6em;
    padding-top: 0.45em;
  }

  .call-indicator-content {
    z-index: ${Z_INDEX.L4};
    width: 75%;
    max-width: 35em;
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: right;
    vertical-align: bottom;
  }

  .call-indicator-call-target {
    font-size: 1.55em;
    margin-bottom: 0.25em;
  }

  .call-indicator-call-duration {
    font-size: 1em;
  }

  .call-indicator-call-duration-quantity {
  }

  .call-indicator-call-duration-units {
    padding-left: 0.2em;
    padding-right: 0.2em;
  }
  @media (min-width: ${BREAKPOINT_MOBILE}px) {
  }
`;

export type CallIndicatorType = {
  callTarget?: string | null;
  callDisplayedDuration?: number;
  callDisplayedDurationUnits?: string;
};

export default function CallIndicator({
  callTarget,
  callDisplayedDuration,
  callDisplayedDurationUnits,
}: CallIndicatorType) {
  return (
    <CallIndicatorStyles>
      <div className="call-indicator-label">Call:</div>
      <div className="call-indicator-content">
        <div className="call-indicator-call-target">{callTarget}</div>
        <div className="call-indicator-call-duration">
          <span className="call-indicator-call-duration-quantity">
            {callDisplayedDuration}
          </span>
          <span className="call-indicator-call-duration-units">
            {callDisplayedDurationUnits}
          </span>
          ago
        </div>
      </div>
    </CallIndicatorStyles>
  );
}
